"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorConstants = exports.Constants = exports.isObject = exports.isArray = void 0;
var isArray = function (value) {
    return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};
exports.isArray = isArray;
var isObject = function (value) {
    return value && typeof value === 'object' ? toString.call(value) === '[object Object]' : false;
};
exports.isObject = isObject;
exports.Constants = {
    RS_FOR: 'rsFor',
    RS_IF: 'rsIf',
    RS_SORT: 'rsSort',
    RS_OF: 'rsOf',
    RS_SHOW: 'rsShow',
    MODEL: 'model',
    DELETE_TAG: 'delete_tag',
    SORT_DESC: 'DESC',
    SELECTED: 'selected',
    CHECKED: 'checked',
    RS_INPUT_FILTER: 'rsInputFilter',
    RS_DATA: 'rsData',
    RS_MONITOR: 'rsMonitor',
};
exports.ErrorConstants = {
    RSIF_SYNTAXT_ERROR: 'Error in template rsIf syntax',
    RSFOR_SYNTAXT_ERROR: 'Error in template rsFor syntax',
    RSOF_SYNTAXT_ERROR: 'Error in template rsOf syntax',
    RSSORT_SYNTAXT_ERROR: 'Error in template rsSort syntax',
};
//# sourceMappingURL=util.js.map